import { render } from "./SupplyPraticheSection.vue?vue&type=template&id=7351a378&scoped=true"
import script from "./SupplyPraticheSection.vue?vue&type=script&lang=js"
export * from "./SupplyPraticheSection.vue?vue&type=script&lang=js"

import "./SupplyPraticheSection.vue?vue&type=style&index=0&id=7351a378&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7351a378"]])

export default __exports__